
const WhatSection = () => {
  const programs = [
    {
      icon: 'ri-user-heart-line',
      title: 'Mentorship',
      description: "One-on-one connections with leaders who've been there. Real talk, real guidance, real impact.",
      color: 'primary',
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Advocacy',
      description: 'Amplifying Latina voices in policy, media, and corporate spaces. We demand a seat at the table.',
      color: 'secondary',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Economic Mobility',
      description: "From entrepreneurship to executive roles, we're building pathways to information for wealth and leadership.",
      color: 'electric',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'MAS Academy',
      description: 'Professional development, skill-building, and leadership training designed for rising Latina talent.',
      color: 'primary',
    },
  ];

  return (
    <section id="what" className="py-32 bg-charcoal relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-primary/10 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="mb-20">
          <h2 className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl text-white mb-6 leading-tight">
            What We Do
          </h2>
          <div className="w-24 h-2 bg-primary mb-8"></div>
          <p className="font-inter text-xl text-white/80 max-w-3xl font-medium">
            We're not just talking about change. We're building it, one Latina leader at a time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm p-10 rounded-2xl border border-white/10 hover:border-primary/50 transition-all duration-300 group"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-${program.color}/20 rounded-xl mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${program.icon} text-3xl text-${program.color}`}></i>
              </div>
              <h3 className="font-poppins font-bold text-3xl text-white mb-4">{program.title}</h3>
              <p className="font-inter text-lg text-white/70 leading-relaxed">{program.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatSection;
